import LoanProModuleLayout from '@/modules/loanpro/layout/LoanProLayout.vue';
const routes = [
  {
    path: 'dashboard',
    name: 'loan-pro-dashboard',
    component: () => import('@/modules/loanpro/views/DashboardPage.vue')
  },
  {
    path: 'loan-pool',
    name: 'loan-pool',
    component: () => import('@/modules/loanpro/views/LoanPoolPage.vue')
  },
  {
    path: 'loan-flow/:id',
    name: 'loan-flow',
    component: () => import('@/modules/loanpro/views/LoanFlowPage.vue')
  },
  {
    path: 'waiver/:id',
    name: 'waiver',
    component: () => import('@/modules/loanpro/views/LoanWaiverRequest.vue')
  },
  {
    path: 'approval/:id',
    name: 'approval',
    component: () => import('@/modules/loanpro/views/LoanApprovalPage.vue')
  },
  {
    path: 'securities-check-assignment',
    name: 'securities-check-assignment',
    component: () => import('@/modules/loanpro/views/workload/LoanSecuritiesCheckPage.vue')
  },
  {
    path: 'assignment-view',
    name: 'assignment-view',
    component: () =>
      import('@/modules/loanpro/views/workload/LoanAssignedPage.vue')
  },
  {
    path: 'waiver-view',
    name: 'waiver-view',
    component: () => import('@/modules/loanpro/views/workload/WaiversPage.vue')
  },
  {
    path: 'approval-view',
    name: 'approval-view',
    component: () =>
      import('@/modules/loanpro/views/workload/ApprovalsPage.vue')
  },
  {
    path: 'disbursement-view',
    name: 'disbursement-view',
    component: () =>
      import('@/modules/loanpro/views/workload/DisbursementsPage.vue')
  },
  {
    path: 'disbursement-view/:id',
    name: 'disbursement-view-id',
    component: () =>
      import('@/modules/loanpro/views/workload/IssueDisbursementsPage.vue')
  },
  {
    path: 'checklist-view',
    name: 'checklist-view',
    component: () =>
      import('@/modules/loanpro/views/workload/LoansForReviewPage.vue')
  },
  {
    path: 'loan-services',
    name: 'loan-services',
    component: () => import('@/modules/loanpro/views/LoanServicePage.vue')
  },
  {
    path: 'policy-information',
    name: 'policy-information',
    component: () => import('@/modules/loanpro/views/PolicyInformationPage.vue')
  },
  {
    path: 'loan-trail',
    name: 'loan-trail',
    component: () => import('@/modules/loanpro/views/LoanTrailPage.vue')
  },
  {
    path: 'loan-reports',
    name: 'loan-reports',
    component: () => import('@/modules/loanpro/views/LoanReportsPage.vue')
  },
  {
    path: 'yapu-reports',
    name: 'yapu-reports',
    component: () => import('@/modules/loanpro/views/YapuReportsPage.vue')
  }
];

export default {
  path: 'loan-pro',
  name: 'loan-pro',
  component: LoanProModuleLayout,
  redirect: {
    name: 'loan-pro-dashboard'
  },
  meta: {
    requiresAuth: true
  },
  children: [...routes]
};
